<template>
  <button
    class="inline-block font-bold text-sm border-solid border-2 border-gray-300 rounded px-3 py-2 mr-1 mb-1"
    :class="{ 'bg-gray-600 text-white border-gray-600 text-white': active }"
  >
    <i v-if="icon" :class="`fas fa-${icon} text-${active ? color : 'gray'}-300 mr-1`"></i>

    {{ label }}
  </button>
</template>

<script>
export default {
  props: ['label', 'icon', 'color', 'active'],
};
</script>

<style></style>
